import React from "react";
import "../Progressivecommon.css";
import './StreamLine.css';
import img1 from '../assetsprogressive/progressive1.png';
import img2 from '../assetsprogressive/progressive2.png';
import img3 from '../assetsprogressive/progressive3.png';
import img4 from '../assetsprogressive/progressive4.png';

export default function StreamLine() {
  const cardData = [
    {
      id: 1,
      img:img1,
      title: "Focus on Creation, Not Cash Flow",
      desc: "We help bridge financial needs so you can keep creating",
      bg: "#ecfae9"
    },
    {
      id: 2,
      img:img2,
      title: "Quick access to Funds",
      desc: "Keep your momentum going with fast and efficient disbursement within a week",
      bg: "#f8ffbc"
    },
    {
      id: 3,
      img:img3,
       title: "Your dedicated Partner",
      desc: "Our Account Managers are here to guide you every step of the way",
      bg: "#d6f6fa"
    },
    {
      id: 4,
      img: img4,
        title: "Simple Onboarding. Powerful Impact",
      desc: "Get funded faster with our tech-driven process: minimal docs, zero manual intervention",
      bg: "#fdeefe"
    }
  ];

  return (
    <div id="streamlineprogressive" className="progressive-wrapper">
      <div className="top">
        
        <div className="left">
            <span>For content producers</span>
            <h1 className='h1-tag'>Streamlined Funding Solutions for Creators</h1>
        </div>
        <div className="right">
            <span>Get upto 90% of Your Future Revenue. Apply Now.</span>
            <button>
              <span className="firstbtn">SCHEDULE A CALL WITH US</span>
               {/* <span className="secondbtn">SCHEDULE A CALL WITH US</span> */}
            </button>
        </div>
      </div>
      <div className="bottom">
        <div className="cards">
          {cardData.map((card) => (
            <div className="card" key={card.id} style={{ backgroundColor: card.bg }}>
              <img src={card.img} alt="error" />
              <h2>{card.title}</h2>
              <p>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
